// extracted by css-extract-rspack-plugin
var _1 = "bty4_pXPqkO5qBId";
var _2 = "TGESprB63t8Vfnzk";
var _3 = "yqzt2U50Q0yMaCkn";
var _4 = "bty4_pXPqkO5qBId";
var _5 = "TGESprB63t8Vfnzk";
var _6 = "yqzt2U50Q0yMaCkn";
var _7 = "qBMWyegzpXsT_STB";
var _8 = "v1DClXcPxHclUduH";
export { _1 as "article-card", _2 as "article-card-description", _3 as "article-card-title", _4 as "articleCard", _5 as "articleCardDescription", _6 as "articleCardTitle", _7 as "img", _8 as "wrapper" }
